import { useState, useRef, useEffect } from "react";

const COLLAPSED_HEIGHT_MOBILE = 80;
const COLLAPSED_HEIGHT_DESKTOP = 57.6;

interface UseErrorExpansionParams {
  errorMessage: string | undefined;
  isMobile: boolean;
}

interface UseErrorExpansionReturn {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  shouldShowButton: boolean;
  messageRef: React.RefObject<HTMLSpanElement>;
}

export function useErrorExpansion({
  errorMessage,
  isMobile,
}: UseErrorExpansionParams): UseErrorExpansionReturn {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const messageRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (messageRef.current && errorMessage) {
      const collapsedHeight = isMobile
        ? COLLAPSED_HEIGHT_MOBILE
        : COLLAPSED_HEIGHT_DESKTOP;
      const scrollHeight = messageRef.current.scrollHeight;
      setShouldShowButton(scrollHeight > collapsedHeight);
    }
  }, [errorMessage, isMobile]);

  return { isExpanded, setIsExpanded, shouldShowButton, messageRef };
}
